var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-nav-top"},[_c('nav',[_c('ul',{staticClass:"menu"},[_c('li',[_c('router-link',{attrs:{"to":"/index/prices"}},[_vm._v("Prices")])],1),_c('li',[_c('router-link',{attrs:{"to":"/index/terms"}},[_vm._v("Terms and Conditions")])],1),_c('li',[_c('router-link',{attrs:{"to":"/console/"}},[_vm._v("Console")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }